var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"dialog",attrs:{"title":"Cancel sending this email?","width":"465","styles":{top: '238px'},"loading":true},on:{"on-ok":_vm.abortSend},model:{value:(_vm.confirmShow),callback:function ($$v) {_vm.confirmShow=$$v},expression:"confirmShow"}},[_vm._v(" This email will be saved as a draft. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }